/**
 * TimelineTodayMarker Component
 *
 * Renders a vertical "Today" marker line with a label and dot.
 * Uses --rp-temporal-red for the marker color.
 */

import type { TimelineTodayMarkerProps } from '../types'

/**
 * TimelineTodayMarker Component
 */
export function TimelineTodayMarker({
  position,
  label = 'Today',
}: TimelineTodayMarkerProps) {
  // Don't render if position is outside visible range
  if (position < 0 || position > 100) {
    return null
  }

  return (
    <div
      className="timeline-today-marker"
      style={{ left: `${position}%` }}
      aria-label={label}
    >
      <div className="timeline-today-marker__line" />
      <div className="timeline-today-marker__dot" />
      <span className="timeline-today-marker__label">{label}</span>
    </div>
  )
}

export default TimelineTodayMarker
